<template>
  <el-select
    v-model="expirationDate"
    size="small"
    :disabled="disabled"
    clearable
    @change="onProductExpirationDateChange"
  >
    <el-option
      v-for="expiration in expirationDates"
      :key="expiration.expiration_date"
      :value="expiration.expiration_date"
      :label="$options.filters.date(expiration.expiration_date)"
    >
      {{ expiration.expiration_date | date }}
      <span
        v-if="expiration.count"
        style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
      >
        <el-tag
          size="mini"
          type="info"
        >
          {{ expiration.count }} {{ packTypeName }} készleten
        </el-tag>
      </span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    packTypeName: {
      type: String,
      default() {
        return 'db';
      },
      required: false,
    },
    availableExpirationDates: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    autoSelectStock: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    defaultExpirationDate: {
      type: String,
      default() {
        return null;
      },
      required: false,
    },
  },
  data() {
    return {
      expirationDate: '',
      expirationDates: [],
    };
  },
  watch: {
    availableExpirationDates(expirationDates) {
      this.expirationDates = expirationDates;
      if (this.autoSelectStock && !this.expirationDate) {
        let count = 0;
        expirationDates.forEach(exp => {
          if (exp.count >= count) {
            this.expirationDate = exp.expiration_date;
            count = exp.count;
          }
        });
        this.onProductExpirationDateChange(this.expirationDate);
      }
    },
    defaultExpirationDate(expirationDate) {
      this.expirationDate = expirationDate;
    },
  },
  mounted() {
    this.expirationDates = this.availableExpirationDates;
    if (this.defaultExpirationDate) {
      this.expirationDate = this.defaultExpirationDate;
      this.onProductExpirationDateChange(this.expirationDate);
    }
  },
  methods: {
    onProductExpirationDateChange(expiration) {
      this.$emit('change', expiration);
    },
  },
};
</script>
